import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SwitchBox } from '../../../molecules/switch-box';

export const SettingsSpInstall = () => {
  return (
    <SwitchBox
      title={
        <FormattedMessage
          id="settings.spot.install"
          defaultMessage="Spotové obchodování aktivní"
        />
      }
      switchVariableId="SP_INSTALL"
      fullWidth
    />
  );
};
